import { inject, Injectable } from '@angular/core';
import { createPointsModel } from '../points/points-model';
import { CompilingFormService } from './compiling-form.service';

/** The points model over the structure currently being compiled. */
@Injectable()
export class CompilingPointsService {
  private readonly forms = inject(CompilingFormService);
  private readonly points = createPointsModel(this.forms.moduleStructure);

  readonly widgetTotalWeights = this.points.widgetTotalWeights;
  readonly subsectionWidgets = this.points.subsectionWidgets;
  readonly subsectionWeights = this.points.subsectionWeights;
  readonly subsectionsPoints = this.points.subsectionsPoints;

  getMaxPointsForWidget(widgetId: string) {
    return this.points.maxPointsForWidget(widgetId);
  }
}
